var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// services
import { EventsService } from '../../core/services/events-service/events.service';
import { ProfileService } from '../../core/services/profile-service/profile.service';
// components
import { AlertComponent, EzValidators } from '../../shared';
// constants
import { tshirtSizes, scrollItType, getPhoneMask, stateList, } from '../../shared';
var OwnerRegistrationComponent = /** @class */ (function () {
    function OwnerRegistrationComponent(fb, calculateAge, scrollIt, eventService, route, profileService) {
        this.fb = fb;
        this.calculateAge = calculateAge;
        this.scrollIt = scrollIt;
        this.eventService = eventService;
        this.route = route;
        this.profileService = profileService;
        this.showValidation = false;
        this.eventId = '';
        this.successHtml = '';
        this.selectedSchoolDetails = null;
    }
    Object.defineProperty(OwnerRegistrationComponent.prototype, "shirtSizes", {
        get: function () {
            return tshirtSizes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OwnerRegistrationComponent.prototype, "waiverText", {
        get: function () {
            return this.eventService.waiver.text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OwnerRegistrationComponent.prototype, "waiverHeader", {
        get: function () {
            return this.eventService.waiver.header;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OwnerRegistrationComponent.prototype, "isClosed", {
        get: function () {
            return this.eventService.isRegistrationClosed('owner');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OwnerRegistrationComponent.prototype, "eventUrl", {
        get: function () {
            return this.eventService.eventData.url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OwnerRegistrationComponent.prototype, "profile", {
        get: function () {
            return this.profileService.profile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OwnerRegistrationComponent.prototype, "isGuest", {
        get: function () {
            return this.profileService.isGuest;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OwnerRegistrationComponent.prototype, "stateList", {
        get: function () {
            return stateList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OwnerRegistrationComponent.prototype, "schools", {
        get: function () {
            return this.eventService.schools;
        },
        enumerable: true,
        configurable: true
    });
    OwnerRegistrationComponent.prototype.ngOnInit = function () {
        this.getEventId();
        this.initializeForm();
        this.watchFormForUpdates();
        this.profileService.patchFormWithProfile(this.form);
    };
    OwnerRegistrationComponent.prototype.getEventId = function () {
        this.eventId = this.route.snapshot.parent.params.id;
    };
    OwnerRegistrationComponent.prototype.documentIdRequired = function () {
        if (this.eventId !== 'svopen2019') {
            return { document_id: ['', Validators.required] };
        }
        else {
            return {};
        }
    };
    OwnerRegistrationComponent.prototype.initializeForm = function () {
        this.form = this.fb.group(__assign({ 
            // personal information
            name_first: ['', Validators.required], name_middle: [''], name_last: ['', Validators.required], birth_date: ['', Validators.required], gender: ['', Validators.required], 
            // contact information
            email: ['', [Validators.required, Validators.email]], phone: ['', Validators.required], address: ['', Validators.required], address_2: [''], city: ['', Validators.required], state: ['', Validators.required], zip: ['', Validators.required] }, this.documentIdRequired(), { 
            // misc information
            // 'shirt_size': 			['', Validators.required],
            school: this.fb.group({
                id: [''],
                name: [''],
                master: [''],
                address: [''],
                address_2: [''],
                city: [''],
                state: [''],
                zip: [''],
                country: [''],
                phone: [''],
                email: [''],
                url: [''],
            }, {
                validator: EzValidators.schoolRequired,
            }), guest_name_first: [], guest_name_last: [], 
            // legal stuff and subsrcriptions
            subscription: [false], owner_confirmation: [false, Validators.requiredTrue], legal_age: [false, Validators.requiredTrue], no_crime: [false, Validators.requiredTrue], waiver: [false, Validators.requiredTrue], terms_and_conditions: [false, Validators.requiredTrue], catchall: [false, Validators.requiredTrue] }));
    };
    OwnerRegistrationComponent.prototype.watchFormForUpdates = function () {
        var _this = this;
        this.form
            .get('school.id')
            .valueChanges.subscribe(function (schoolId) {
            _this.getSchoolDetails(schoolId);
        });
    };
    OwnerRegistrationComponent.prototype.getSchoolDetails = function (schoolId) {
        var _this = this;
        this.selectedSchoolDetails = null;
        this.form.get('school.name').reset();
        this.form.get('school.master').reset();
        this.form.get('school.address').reset();
        this.form.get('school.address_2').reset();
        this.form.get('school.city').reset();
        this.form.get('school.state').reset();
        this.form.get('school.zip').reset();
        this.form.get('school.country').reset();
        this.form.get('school.phone').reset();
        this.form.get('school.email').reset();
        this.form.get('school.url').reset();
        if (this.schoolAlert) {
            this.schoolAlert.closeAlert();
        }
        if (schoolId === '-1' || !schoolId) {
            return;
        }
        this.eventService.getSchoolDetails(this.eventId, schoolId).subscribe(function (res) {
            _this.selectedSchoolDetails = res;
            _this.form.get('school.name').setValue(res.name);
            _this.form.get('school.master').setValue(res.master);
            _this.form.get('school.address').setValue(res.address);
            _this.form.get('school.address_2').setValue(res.address_2);
            _this.form.get('school.city').setValue(res.city);
            _this.form.get('school.state').setValue(res.state);
            _this.form.get('school.zip').setValue(res.zip);
            _this.form.get('school.country').setValue(res.country);
            _this.form.get('school.phone').setValue(res.phone);
            _this.form.get('school.email').setValue(res.email);
            _this.form.get('school.url').setValue(res.url);
        }, function (err) {
            if (_this.schoolAlert) {
                _this.schoolAlert.newAlert(err.error.detail, 'danger');
            }
        });
    };
    OwnerRegistrationComponent.prototype.showSchoolDetails = function () {
        var selectedSchoolId = this.form.get('school.id').value;
        return (selectedSchoolId === '-1' ||
            (selectedSchoolId !== '-1' && this.selectedSchoolDetails));
    };
    OwnerRegistrationComponent.prototype.onSubmit = function () {
        var _this = this;
        this.scrollIt(0);
        if (this.form.invalid) {
            this.alert.newAlert('Please fill out required fields', 'danger');
            this.showValidation = true;
            return;
        }
        this.alert.newAlert('Submitting...', 'info');
        this.eventService
            .postEntity(this.eventId, 'owners', this.form.value)
            .subscribe(function (res) {
            if (res && res._html_message) {
                _this.successHtml = res._html_message;
            }
            else {
                _this.alert.newAlert('There was an error', 'danger');
            }
        }, function (err) {
            _this.alert.newAlert(err.error.detail || 'There was an error', 'danger');
        });
    };
    OwnerRegistrationComponent.prototype.resetForm = function () {
        this.form.reset();
        this.successHtml = '';
        this.showValidation = false;
    };
    OwnerRegistrationComponent.prototype.isMinor = function (formGroup) {
        var birth_date = formGroup.get('birth_date').value;
        return this.calculateAge(new Date(birth_date)) < 18;
    };
    OwnerRegistrationComponent.prototype.openModal = function (event, modalName) {
        event.preventDefault();
        switch (modalName) {
            case 'waiver':
                this.waiverModal.open();
                break;
            case 'terms':
                this.termsModal.open();
                break;
            default:
                break;
        }
    };
    OwnerRegistrationComponent.prototype.getPhoneMask = function (formControl) {
        return getPhoneMask(this.form.get(formControl).value);
    };
    return OwnerRegistrationComponent;
}());
export { OwnerRegistrationComponent };
